import React, {PureComponent, ReactNode} from 'react';
import {BR_VERIFIED} from 'app/consts';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class BookmakerRating extends PureComponent {
    render(): ReactNode {
        if (I18n.locale !== 'ru') {
            return null;
        }
        return <>
            <div className="bookmaker-stamp">
                <img src={BR_VERIFIED} alt="Рейтинг букмекеров" title="Проверено Рейтингом Букмекеров"/>
            </div>
            <div className="bookmaker-rating">
                <span className="bookmaker-rating__logo">
                    <SpriteIcon name="#svg-raiting" className="svg-default"/>
                </span>
                <span className="bookmaker-rating__rating">Оценка: 5</span>
            </div>
        </>;
    }
}
